import { MainInner } from "@/styles/global";
import { Link } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import * as React from "react";

import S from "./Header.style";
import useHeaderData from "./useHeaderData";

const Header: React.FC = () => {
  const data = useHeaderData();
  const [isOpen, setIsOpen] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);

  const { linkLeft, linksRight, logo, socialLinksHeader } = data.header;

  const logoImageData = logo?.localFile?.childImageSharp?.gatsbyImageData
    ? getImage(logo.localFile.childImageSharp.gatsbyImageData)
    : null;

  const [isLinkActive, setIsLinkActive] = React.useState("");
  const [isHome, setIsHome] = React.useState(false);

  React.useEffect(() => {
    // check if on home page
    if (window.location.pathname === "/") {
      setIsHome(true);
    }
  }, []);

  // if on home page, set isLinkActive to linkLeft.title
  React.useEffect(() => {
    if (window.location.pathname === "/") {
      setIsLinkActive(linkLeft.title);
    } else {
      linksRight.map((link) => {
        if (window.location.pathname.includes(link.link.url)) {
          setIsLinkActive(link.link.title);
        }
      });
    }
  }, []);

  // check if scrolled
  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Prevent body scrollin when isOpen is true
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.height = "100vh";
      document.body.style.overflow = "hidden";
      // scroll to top
      // window.scrollTo(0, 0);
    } else {
      document.body.style.height = "auto";
      document.body.style.overflow = "unset";
    }
  }, [isOpen]);

  // hide when scrolling down, show when scrolling up
  const [lastScrollTop, setLastScrollTop] = React.useState(0);
  const [scrollDirection, setScrollDirection] = React.useState("up");
  const [offsetY, setOffsetY] = React.useState(0);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window) {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
          setScrollDirection("down");
        } else {
          setTimeout(() => {
            setScrollDirection("up");
          }, 500);
        }
        setLastScrollTop(st <= 0 ? 0 : st);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const renderLinks = () => {
    return linksRight.map((link, i) => {
      return (
        <S.HeaderLink
          isHome={isHome}
          isScrolled={isScrolled}
          active={isLinkActive === link.link.title}
          key={i}
          to={link.link.url}
        >
          <S.HeaderLine active={isLinkActive === link.link.title} />
          {link.link.title}
        </S.HeaderLink>
      );
    });
  };

  const renderMobileLinks = () => {
    return linksRight.map((link, i) => {
      return (
        <S.MobileLink isOpen={isOpen} key={i} to={link.link.url}>
          {link.link.title}
        </S.MobileLink>
      );
    });
  };

  const renderSocialLinks = () => {
    return socialLinksHeader.map((link, index) => {
      return (
        <S.SocialLink
          key={index}
          isOpen={isOpen}
          href={link.link.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.link.title}
        </S.SocialLink>
      );
    });
  };

  React.useEffect(() => {
    // offset windo.pageYOffset when scrolling
    const handleScroll = () => {
      setOffsetY(window.pageYOffset);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <S.Container
      isScrolled={isScrolled}
      isOpen={isOpen}
      scrollDirection={scrollDirection}
      offsetY={offsetY}
      isHome={isHome}
    >
      <MainInner>
        <S.HeaderWrapper>
          {linkLeft && (
            <S.HeaderLink
              active={isLinkActive === linkLeft.title}
              to={linkLeft.url}
              isHome={isHome}
              isScrolled={isScrolled}
            >
              <S.HeaderLine active={isLinkActive === linkLeft.title} />
              {linkLeft.title}
            </S.HeaderLink>
          )}
          {logo && logoImageData && (
            <Link to="/">
              <S.LogoWrapper isScrolled={isScrolled}>
                <S.Logo
                  isOpen={isOpen}
                  isHome={isHome}
                  scrolled={isScrolled}
                  image={logoImageData}
                  alt={logo.altText || ""}
                />
              </S.LogoWrapper>
            </Link>
          )}
          <S.Hamburger onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
            <S.HamburgerLine1
              isHome={isHome}
              isScrolled={isScrolled}
              isOpen={isOpen}
            />
            <S.HamburgerLine2
              isHome={isHome}
              isScrolled={isScrolled}
              isOpen={isOpen}
            />
            <S.HamburgerLine3
              isHome={isHome}
              isScrolled={isScrolled}
              isOpen={isOpen}
            />
          </S.Hamburger>
          {linksRight && <S.LinksWrapper>{renderLinks()}</S.LinksWrapper>}
        </S.HeaderWrapper>
      </MainInner>
      <S.MobileMenu isScrolled={isScrolled} isOpen={isOpen}>
        <MainInner>
          <S.MobileLinksWrapper isOpen={isOpen}>
            {renderMobileLinks()}
          </S.MobileLinksWrapper>
          <S.SocialLinkWrapper>{renderSocialLinks()}</S.SocialLinkWrapper>
        </MainInner>
      </S.MobileMenu>
    </S.Container>
  );
};
export default Header;
